// Prefetch the JS chunks for routes the user is likely to visit next.
// Call these from hover handlers on links/buttons so the chunk downloads
// BEFORE the click, eliminating the PageLoader flash on the first visit
// to a lazy route. React's dynamic import() caches internally, so repeated
// calls are cheap — the browser dedupes the network request.

export const prefetchTopicDetail = () => import('../pages/TopicDetail');
export const prefetchCreateQuiz = () => import('../pages/CreateQuiz');
export const prefetchBrowseQuizzes = () => import('../pages/BrowseQuizzes');
export const prefetchGamesIndex = () => import('../pages/games/GamesIndex');
export const prefetchTugOfWar = () => import('../pages/games/TugOfWar');
export const prefetchKnowledgeClimb = () => import('../pages/games/KnowledgeClimb');
export const prefetchSpeedSprint = () => import('../pages/games/SpeedSprint');
export const prefetchRocketRace = () => import('../pages/games/RocketRace');
export const prefetchCredits = () => import('../pages/Credits');
export const prefetchLeaderboard = () => import('../pages/Leaderboard');
export const prefetchDashboard = () => import('../pages/Dashboard');
export const prefetchTestInterface = () => import('../pages/TestInterface');
export const prefetchResults = () => import('../pages/Results');
export const prefetchArticles = () => import('../pages/Articles');

/**
 * Map a URL pathname to its prefetcher. Use as `onMouseEnter={() => prefetchRouteForPath(path)}`.
 * Safe for unknown paths (returns undefined, noop).
 */
export function prefetchRouteForPath(path) {
  if (!path) return;
  if (path === '/create') return prefetchCreateQuiz();
  if (path === '/quizzes') return prefetchBrowseQuizzes();
  if (path === '/games') return prefetchGamesIndex();
  if (path === '/credits' || path.startsWith('/credits/')) return prefetchCredits();
  if (path === '/leaderboard') return prefetchLeaderboard();
  if (path === '/dashboard') return prefetchDashboard();
  if (path === '/articles' || path.startsWith('/articles/')) return prefetchArticles();
  if (path.startsWith('/topic/')) return prefetchTopicDetail();
  if (path.startsWith('/games/tug-of-war')) return prefetchTugOfWar();
  if (path.startsWith('/games/knowledge-climb')) return prefetchKnowledgeClimb();
  if (path.startsWith('/games/speed-sprint')) return prefetchSpeedSprint();
  if (path.startsWith('/games/rocket-race')) return prefetchRocketRace();
}
